import { useTranslation } from 'react-i18next'

import { DetailList } from './DetailList'
import { ItemText } from './ItemText'

import { TransactionInput } from '../../../apis/fvillage'
import { Col, Container, Row } from '../../basics'

type UsageInfoDetailListProps = TransactionInput

const translateNamespace = `components.ReservationDetail`

export const UsageInfoDetailList: React.FC<UsageInfoDetailListProps> = ({
  companyName,
  purposeOfUse,
  checkInTime,
}) => {
  const { t } = useTranslation()

  if (!companyName && !purposeOfUse && !checkInTime) {
    return null
  }

  const items = [
    ...(companyName
      ? [
          <Container>
            <Row>
              <Col pc={3} sp={12}>
                <ItemText>{t(`${translateNamespace}.companyName`)}</ItemText>
              </Col>
              <Col pc={9} sp={12}>
                <ItemText>{companyName}</ItemText>
              </Col>
            </Row>
          </Container>,
        ]
      : []),
    ...(purposeOfUse
      ? [
          <Container>
            <Row>
              <Col pc={3} sp={12}>
                <ItemText>{t(`${translateNamespace}.purposeOfUse`)}</ItemText>
              </Col>
              <Col pc={9} sp={12}>
                <ItemText>{purposeOfUse}</ItemText>
              </Col>
            </Row>
          </Container>,
        ]
      : []),
    ...(checkInTime
      ? [
          <Container>
            <Row>
              <Col pc={3} sp={12}>
                <ItemText>{t(`${translateNamespace}.checkInTime`)}</ItemText>
              </Col>
              <Col pc={9} sp={12}>
                <ItemText>{checkInTime}</ItemText>
              </Col>
            </Row>
          </Container>,
        ]
      : []),
  ]

  return (
    <DetailList
      header={t(`${translateNamespace}.usageInfo`)}
      listItems={[
        {
          items,
          key: 'usageInfo',
        },
      ]}
    />
  )
}
